import React from 'react';

const AdditionalInfo = ({ additional, standard }) => {
	// eslint-disable-next-line eqeqeq
	const description = additional.description != null ?
		additional.description : (standard ? additional.stdDimension : additional.unitDimenstion);
	return (
		<li>
			<img src={ additional.image } alt="" />
			<h3>{ additional.name }</h3>
			<p>{ description }</p>
		</li>
	);
};

export default AdditionalInfo;


// WEBPACK FOOTER //
// ./src/pages/product/AdditionalInfo.js